import React from "react";
import HowToRegOutlinedIcon from "@mui/icons-material/HowToRegOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import AdsClickOutlinedIcon from "@mui/icons-material/AdsClickOutlined";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";

const KotMenus = [
  {
    label: "sidebar.menu.kot",
    type: "section",
    children: [
      {
        uri: "/kot/active-clients",
        label: "sidebar.menuItem.active-clients",
        type: "nav-item",
        icon: <HowToRegOutlinedIcon sx={{ fontSize: 20 }} />,
      },

      {
        uri: "/kot/favorites",
        label: "sidebar.menuItem.favorites",
        type: "nav-item",
        icon: <StarBorderOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/kot/track-changes",
        label: "sidebar.menuItem.track-changes",
        type: "nav-item",
        icon: <AdsClickOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        uri: "/kot/inactive-clients",
        label: "sidebar.menuItem.inactive-clients",
        type: "nav-item",
        icon: <PersonOffOutlinedIcon sx={{ fontSize: 20 }} />,
      },
      {
        label: "sidebar.menuItem.reports",
        type: "collapsible",
        defaultOpen: false,
        icon: <ArticleOutlinedIcon sx={{ fontSize: 20 }} />,
        children: [
          {
            uri: "/kot/reports/inventor-details",
            label: "Inventor Details",
            type: "nav-item",
          },
          {
            uri: "/kot/reports/licensing-summary",
            label: "Licensing Summary",
            type: "nav-item",
          },
          {
            uri: "/kot/reports/entity-status",
            label: "Entity Status",
            type: "nav-item",
          },
        ]
      },
    ],
  },
];

export default KotMenus;
